import React, { FC, useState } from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Category } from 'shared/types/product/Category';
import Button from 'components/commercetools-ui/atoms/button';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import { useFormat } from 'helpers/hooks/useFormat';
import { DataSource } from 'types/next';
import { Reference } from 'types/reference';
import { ImageProps } from 'frontastic/lib/image';
import MobileMenuDefault from './content/mobile-menu-default';
import MobileMenuFooter from './content/mobile-menu-footer';
import MobileMenuHeader from './content/mobile-menu-header';
import { menu } from '../../index';
import { MenuItem } from 'frontastic/tastics/header/mega-menu';
export interface Props {
  logo: ImageProps;
  logoLink: Reference;
  links: Category[];
  data: MenuItem | undefined;
  contentFulHeader: boolean;
}

const HeaderNavigationMobile: FC<Props> = ({ logo, logoLink, data, contentFulHeader }) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const [categoriesNavigator, setCategoriesNavigator] = useState<Category[]>([]);
  const [showMenu, setShowMenu] = useState(false);

  const showHeaderMenu = () => {
    setShowMenu(true);
  };

  const hideHeaderMenu = () => {
    setShowMenu(false);
    setCategoriesNavigator([]);
  };

  const removeCategory = () => {
    setCategoriesNavigator((array) => array.slice(0, -1));
  };

  const insertCategory = (category: Category) => {
    setCategoriesNavigator((array) => [...array, category]);
  };
  return !contentFulHeader ? (
    <div className="flex xl:hidden">
      <Button
        variant="ghost"
        size="fit"
        onClick={showMenu ? hideHeaderMenu : showHeaderMenu}
        title={formatMessage({ id: 'header.menu.open', defaultMessage: 'Open side menu' })}
        className="mr-8"
      >
        {showMenu ? (
          <XMarkIcon className="w-24 text-black sm:w-30 lg:w-48" />
        ) : (
          <Bars3Icon className="w-24 text-black sm:w-30 lg:w-48" />
        )}{' '}
      </Button>

      <Drawer
        isOpen={showMenu}
        direction="left"
        className="w-full overflow-y-scroll border border-neutral-400 bg-neutral-100 md:w-[320px]"
        onClose={hideHeaderMenu}
      >
        {/*
        <MobileMenuHeader
          categories={categoriesNavigator}
          hideHeaderMenu={hideHeaderMenu}
          logo={logo}
          logoLink={logoLink}
          onArrowClick={removeCategory}
        />
        */}

        <MobileMenuDefault data={undefined} isOpen={showMenu} />
        {/* <MobileMenu
          links={links}
          hideHeaderMenu={hideHeaderMenu}
          categoriesNavigator={categoriesNavigator}
          insertCategory={insertCategory}
        /> */}

        {categoriesNavigator.length <= 0 && (
          <MobileMenuFooter showMenu={showMenu} hideHeaderMenu={hideHeaderMenu} insertCategory={insertCategory} />
        )}
      </Drawer>
    </div>
  ) : (
    <div className="flex lg:hidden">
      <Button
        variant="ghost"
        size="fit"
        onClick={showMenu ? hideHeaderMenu : showHeaderMenu}
        title={formatMessage({ id: 'header.menu.open', defaultMessage: 'Open side menu' })}
        className="mr-8 cursor-pointer text-start md:w-75"
      >
        {showMenu ? (
          <XMarkIcon className="w-24 text-black sm:w-30 lg:w-48" />
        ) : (
          <Bars3Icon className="w-24 text-black sm:w-30 lg:w-48" />
        )}{' '}
        <p className="text-[9px] font-medium leading-3 text-black md:pl-3">
          {formatMessage({ id: 'menu', defaultMessage: 'MENU' })}
        </p>
      </Button>

      <Drawer
        isOpen={showMenu}
        direction="left"
        className=" w-4/5 overflow-y-scroll bg-neutral-100 pb-40"
        onClose={hideHeaderMenu}
      >
        {/* <MobileMenuHeader
          categories={categoriesNavigator}
          hideHeaderMenu={hideHeaderMenu}
          logo={logo}
          logoLink={logoLink}
          onArrowClick={removeCategory}
        /> */}

        <MobileMenuDefault data={data} isOpen={showMenu} />
        {/* <MobileMenu
          links={links}
          hideHeaderMenu={hideHeaderMenu}
          categoriesNavigator={categoriesNavigator}
          insertCategory={insertCategory}
        /> */}

        {categoriesNavigator?.length <= 0 && (
          <MobileMenuFooter showMenu={showMenu} hideHeaderMenu={hideHeaderMenu} insertCategory={insertCategory} />
        )}
      </Drawer>
    </div>
  );
};

export default HeaderNavigationMobile;
